import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { AlertTriangle } from 'lucide-react';

const PriorityChart = ({ tickets, cardClasses, isDarkMode }) => {
  // Contar tickets por prioridad
  const priorityCounts = tickets.reduce((acc, ticket) => {
    const prioridad = ticket.Prioridad || 'Sin prioridad';
    acc[prioridad] = (acc[prioridad] || 0) + 1;
    return acc;
  }, {});

  const priorityData = [
    { name: 'Critica', value: priorityCounts['Critica'] || 0 },
    { name: 'Alta', value: priorityCounts['Alta'] || 0 },
    { name: 'Media', value: priorityCounts['Media'] || 0 },
    { name: 'Baja', value: priorityCounts['Baja'] || 0 },
  ];

  return (
    <div className={`${cardClasses} p-6 rounded-2xl`}>
      <h3 className="text-xl font-bold mb-4 flex items-center">
        <AlertTriangle className="w-6 h-6 mr-2 text-yellow-400" />
        Tickets por Prioridad
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={priorityData}>
          <CartesianGrid strokeDasharray="3 3" stroke={isDarkMode ? '#374151' : '#E5E7EB'} />
          <XAxis dataKey="name" stroke={isDarkMode ? '#9CA3AF' : '#6B7280'} />
          <YAxis stroke={isDarkMode ? '#9CA3AF' : '#6B7280'} />
          <Tooltip 
            contentStyle={{
              backgroundColor: isDarkMode ? '#1F2937' : 'white',
              border: 'none',
              borderRadius: '12px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
            }}
            cursor={{ 
              fill: isDarkMode ? 'rgba(59, 130, 246, 0.1)' : 'rgba(59, 130, 246, 0.05)',
              stroke: 'none'
            }}
          />
          <Bar dataKey="value" fill="url(#priorityGradient)" radius={[4, 4, 0, 0]} />
          <defs>
            <linearGradient id="priorityGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8B5CF6" stopOpacity={0.9}/>
              <stop offset="95%" stopColor="#3B82F6" stopOpacity={0.7}/>
            </linearGradient>
          </defs>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PriorityChart;